module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2pKi1"))).then(() => parcelRequire('37nVf'));